import { withChartLayout } from 'components/common';
import ModifiedBradenQScale from 'components/features/chart/special-charts/modified-braden-q-scale/ModifiedBradenQScale';

const ModifiedBradenQScalePage = withChartLayout('Modified Braden Q Scale')(ModifiedBradenQScale);
export default ModifiedBradenQScalePage;
